import React from "react";
import { useLang } from "@/contexts/LanguageContext";
import { journalArticles } from "@/lib/translations";
import Reveal from "@/components/Reveal";

export default function Journal() {
  const { lang, t } = useLang();
  const articles = journalArticles[lang];

  return (
    <div data-testid="journal-page" className="bg-maly-cream">
      <section className="pt-40 lg:pt-48 pb-20 px-6 lg:px-12 text-center">
        <Reveal>
          <div className="font-body text-[11px] tracking-[0.3em] uppercase text-maly-navy/60 mb-8">{t.journal.overline}</div>
        </Reveal>
        <Reveal delay={100}>
          <h1 className="font-display text-5xl sm:text-6xl lg:text-8xl font-light tracking-[-0.02em] leading-[1.02] max-w-4xl mx-auto">{t.journal.headline}</h1>
        </Reveal>
        <Reveal delay={200}>
          <p className="font-serif italic text-lg lg:text-xl opacity-70 mt-8 max-w-2xl mx-auto leading-relaxed">{t.journal.sub}</p>
        </Reveal>
      </section>

      {/* Featured article */}
      <section className="px-6 lg:px-12 mb-24">
        <Reveal className="max-w-[1500px] mx-auto grid lg:grid-cols-12 gap-8 lg:gap-16 items-center">
          <div className="lg:col-span-7 aspect-[4/3] img-zoom bg-maly-creamDeep">
            <img src={articles[0].image} alt={articles[0].title} className="w-full h-full object-cover" loading="lazy" />
          </div>
          <div className="lg:col-span-5">
            <div className="font-body text-[10px] tracking-[0.3em] uppercase text-maly-gold mb-4">{articles[0].tag} · {articles[0].date} · {articles[0].readTime}</div>
            <h2 className="font-display text-4xl lg:text-5xl font-light tracking-[-0.01em] leading-[1.05]">{articles[0].title}</h2>
            <p className="font-body text-base lg:text-lg opacity-70 mt-6 leading-relaxed">{articles[0].excerpt}</p>
            <a className="inline-block mt-8 font-body text-[11px] tracking-[0.25em] uppercase font-medium link-underline cursor-pointer">
              {t.common.readMore} →
            </a>
          </div>
        </Reveal>
      </section>

      {/* Article grid */}
      <section className="px-6 lg:px-12 pb-32">
        <div className="max-w-[1500px] mx-auto grid md:grid-cols-3 gap-10 lg:gap-16">
          {articles.slice(1).map((a, i) => (
            <Reveal key={i} delay={i * 100}>
              <article className="group cursor-pointer">
                <div className="aspect-[4/5] img-zoom bg-maly-creamDeep mb-6">
                  <img src={a.image} alt={a.title} className="w-full h-full object-cover" loading="lazy" />
                </div>
                <div className="font-body text-[10px] tracking-[0.3em] uppercase text-maly-gold mb-3">{a.tag} · {a.date}</div>
                <h3 className="font-display text-2xl lg:text-3xl leading-snug font-light group-hover:opacity-70 transition-opacity">{a.title}</h3>
                <p className="font-body text-sm opacity-65 mt-4 leading-relaxed">{a.excerpt}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
